export default __webpack_public_path__ + "static/media/Qaumah.4cccbb63.mp3";